import React from 'react';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';
import StyledImg from './styles';
import lightIcon from "./img/icon-info-white.png";
import darkIcon from "./img/icon-info-dark.png";

const Tooltip = (props) => {

    const { mode, tip, ...rest } = props;
    let src = darkIcon;
    if (props.mode === "light") {
        src = lightIcon;
    }

    return (
        <React.Fragment>
            <StyledImg {...rest} src={src} data-tip={props.tip} />
            <ReactTooltip className="som-tooltip" html={true} type="dark" effect="solid" place="bottom" event="mouseover"
                eventOff="mouseout" offset={{ top: -5 }} multiline={true} />
        </React.Fragment>
    )
}
Tooltip.propTypes = {
    mode: PropTypes.oneOf(['light', 'dark']),
    tip: PropTypes.string,
    marginLeft: PropTypes.number,

}
Tooltip.defaultProps = {
    mode: 'dark',
    tip: "",
    marginLeft: 0
}
export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/Tooltip/index.js